/**
 * Service tokens for DI resolution.
 * Prefer importing these tokens over using string literals.
 */
export const SERVICE_TOKENS = {
  EVENTS: 'events',
  ROUTER: 'router',
  API: 'api',
  STORAGE: 'storage',
  PROMPTS: 'prompts',
  INITIATIVES: 'initiatives',
  ANALYTICS: 'analytics',
  FEEDBACK: 'feedback',
  CAUSALITY: 'causality'
};

export default SERVICE_TOKENS;
